module.exports = __webpack_public_path__ + "img/11.fcab585d.png";